<mat-tab-group mat-stretch-tabs="false" animationDuration="0ms">
  <mat-tab label="Detail"> <app-appointment-detail></app-appointment-detail></mat-tab>
  <mat-tab label="Answers"> <app-appointment-answers></app-appointment-answers> </mat-tab>
  <mat-tab label="Note"> <app-appointment-note></app-appointment-note> </mat-tab>
  <mat-tab label="Codes"> <app-appointment-codes></app-appointment-codes> </mat-tab>
  <mat-tab label="Pre-Visit"> <app-appointment-pre-visit></app-appointment-pre-visit> </mat-tab>
  <mat-tab label="Files"> <app-appointment-files></app-appointment-files> </mat-tab>
</mat-tab-group>
